import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonDirective } from "primeng/button";
import { NewUiErrorPageComponent } from "../../shared/error-page/new-ui-error-page.component";
import { TranslateDirective } from "../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-not-found",
  templateUrl: "./new-ui-not-found.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, RouterLink, ButtonDirective, NewUiErrorPageComponent],
})
export class NewUiNotFoundComponent {}
